import type { FeedbackSubmitOptions } from 'react-common'
import { useDataLakeContext } from 'react-common'
import Bowser from 'bowser'
import { useEventLogger } from '@/hooks/useEventLogger'

function getParser() {
  return Bowser.getParser(window.navigator.userAgent)
}

export const useHandleFeedbackSubmit = () => {
  const { dataLakeClient } = useDataLakeContext()
  const { logEvent } = useEventLogger()

  return ({ answers, grade, text }: FeedbackSubmitOptions) => {
    const parsed = getParser()

    dataLakeClient.setOverrides({
      context_os_name: parsed.getOS().name,
      context_os_version: parsed.getOS().version,
      context_client_name: parsed.getBrowser().name,
      context_client_version: parsed.getBrowser().version,
    })

    logEvent('product_feedback', {
      grade: grade?.value,
      details: answers as Record<string, boolean>,
      comment: text,
    })
  }
}
